import { DateTime } from 'luxon'
import { DateFormatter } from './date-formatter'

export function DateRangeFormatter({
	dateFrom,
	dateTo,
	format,
}: {
	dateFrom: DateTime
	dateTo: DateTime
	format?: string
}) {
	return (
		<>
			<DateFormatter date={dateFrom} format={format} /> -{' '}
			<DateFormatter date={dateTo} format={format} />
		</>
	)
}
